// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1rl70","title":"ClientInsurance_title__2kvEr","itemText":"ClientInsurance_itemText__2_Iib"};